import { FC } from 'react';
import { useAtomValue } from 'jotai/index';
import { SHARING_FB_PID, useFBActiveUrl } from '~/utils/active/use-fb-active-url';
import { $SharingPageLevelTraffic } from 'shared/atoms';
import { $CurrentHashtagInfoAsAvailable } from '@hashtag/shared/current-hashtag-info';

export const HashtagFacebook: FC = () => {
  const { canonicalUrl } = useAtomValue($SharingPageLevelTraffic);
  const hashtag = useAtomValue($CurrentHashtagInfoAsAvailable);

  const openUrl = useFBActiveUrl({
    pid: SHARING_FB_PID,
    pageType: 'hashtag',
    hashtagId: hashtag.id,
  });

  return (
    <>
      <meta property="al:ios:url" content={openUrl} />
      <meta property="al:ios:app_store_id" content="1498607143" />
      <meta property="al:ios:app_name" content="Lemon8" />
      <meta property="al:android:url" content={openUrl} />
      <meta property="al:android:app_name" content="Lemon8" />
      <meta property="al:android:package" content="com.bd.nproject" />
      <meta property="al:web:url" content={canonicalUrl} />
    </>
  );
};
